export default "__VITE_ASSET__DH2Z83X6__"